<template>
  <common-page-edit
    :title="title"
    :nameRoleEntity="nameRoleEntity"
    :apiNameGet="apiNameGet"
    :apiNameCreate="apiNameCreate"
    :apiNameUpdate="apiNameUpdate"
    :routeNameShow="routeNameShow"
    :routeNameCreate="routeNameCreate"
    :keyRoute="'PolicyId'"
    :backUrl="pathBack"
    @set-loadData="setLoadData"
    :convertLoadData="convertLoadData"
    :paramsSave="paramsSave"
    :isDefaultConverter="false"
    :paramsSend="paramsSend"
  >
    <template v-slot:block2>
      <PolicyData/>
    </template>
  </common-page-edit>
</template>
<script>
import { API_METHODS, FIELD_LANG_POLICY } from "../../../../constant";
import { NAME_OBJECT } from "../../../../RoleConstanans";

import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";
import PolicyData from '../corpPolicy/PolicyData.vue';
import CommonPageEdit from '../../commonElement/CommonPageEdit.vue';

export default {
  name: "EditPageCorpPolicy",
  components: {
    CommonPageEdit,
    PolicyData
  },
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,

      routeNameShow: "CorpPolityShow",
      routeNameCreate: "CorpPolityCreate",

      pathBack: "/corpPolicy",
      apiNameGet: API_METHODS.GET_POLICY,
      apiNameCreate: API_METHODS.CREATE_POLICY,
      apiNameUpdate: API_METHODS.UPDATE_POLICY,
      loadData: null
    };
  },
  computed: {
    title() {
      let text1 = this.$t("Просмотр корпоративной политики");
      let text2 = this.$t("Создание корпоративной политики");
      let text3 = this.$t("Редактирование корпоративной политики");

      let findShow = this.$route.path.indexOf("show");
      if (findShow != -1) {
        return text1;
      }
      let findCreate = this.$route.path.indexOf("create");
      if (findCreate != -1) {
        return text2;
      }
      let findEdit = this.$route.path.indexOf("edit");
      if (findEdit != -1) {
        return text3;
      }
      return text1;
    },
    nameRoleEntity() {
      return NAME_OBJECT.corpPolity;
    },
    paramsSend() {
      return {
         id: this.$route.params.PolicyId || "0",
      };
    }
  },
  beforeRouteEnter(to, from, next) {
    let fromName = from ? from.name : null;
    console.log(fromName);
    next(vm => {

      if (fromName == "ContractEdit") {
        vm.pathBack = from.fullPath;
      }
      if (fromName == "ContractShow") {
        vm.pathBack = from.fullPath;
      }
    });
  },
  methods: {
    convertLoadData(res) {
      let loadData = res.object;
      let fieldInfoList = res.fieldInfoList;
      let scheme = { configForm: [] };

      scheme.configForm = convertFieldInfoListToScheme({
        fieldInfoList,
        langFieldName: FIELD_LANG_POLICY
      });

      return {
        loadData,
        fieldInfoList,
        scheme
      };
    },
    setLoadData(loadData) {
      this.loadData = loadData;
    },

    paramsSave() {
      return {
        id: this.$route.params.PolicyId,
      };
    }
  }
};
</script>

